export enum TextConstants {
  EDIT_CONSIGNMENT_TITLE = "EDIT CONSIGNMENT : ",
  UPDATE_CONSIGNMENT_STATUS = "Update Status",
  REASON = "Reason",
  COMMENTS = "Comments",
  CONSIGNMENT_WARNING = "This consignment will no longer be delivered",
  POD_UPLOADED = "POD uploaded",
  POD_NOT_UPLOADED = "POD not uploaded",
  INSIDE_GEOFENCE = "Inside geofence",
  OUTSIDE_GEOFENCE = "Outside geofence",
  CANNOT_MARK_AS_DELIVERED_TITLE = "Cannot mark as delivered",
  CANNOT_MARK_AS_DELIVERED_DESCRIPTION = "Driver has not uploaded proof of delivery. Ask the driver to upload POD before this order can be marked delivered.",
  REJECT_ITEMS_TITLE = "Edit Rejected Items",
  REJECT_ITEMS_CONTENT = "You will not be able to edit the order details after this status change.",
  REJECT_ITEMS_CONTENT_DESC = "Please go ahead and make changes to the item summary if you have any",
  STORES_LABEL = "Stores",
  DATE_LABEL = "Date",
  VALID_END_TIME = "Please enter valid end time",
  ADD_COMMENT = "Add a new comment",
  ADDITIONAL_INFO = "Additional information",
  ORDERS_VERIFIED = "Orders Verified (% of Total)",
  ORDERS_WITH_ISSUES = "Orders with Issues (% of Verified)",
  COLLECTED = "Collected",
  COLLECT = "Collect",
  TOTAL_COD_ORDERS = "Total COD orders",
  TOTAL_ORDERS_AMOUNT = "Total Orders amount",
  TOTAL_COD_COLLECTED = "Total COD collected",
  COD_AMOUNT_RECEIVED = "COD amount received",
  TOTAL_COD_AMOUNT = "Total COD amount",
  REASON_ATTEMPTED_DELIVERY = "Reason for Attempted delivery",
  CONSIGNMENT_VERIFIED = "Consignment Verified (% of Total)",
  CONSIGNMENT_WITH_ISSUES = "Consignment with Issues (% of Verified)",
  EXPORT_DRIVER_DATA= "Export Driver Data",
  EXPORT_ORDER_DATA="Export Order Data",
  EXPORT_COD_SUMMARY="Export Summary",
  MODAL_CLOSE_BUTTON="Modal close button",
  NO_DATA="Please select a file",
  DOWNLOAD_PDF="Download PDF",
  ACTIVITY_TYPE = "Activity Type",
  SEARCH_BY_DRIVER_NAME = "Search by driver name",
  ASSIGNED = "Assigned",
  UNASSIGNED = "Unassigned",
  CONSIGNMENTID = "Consignment ID",
  MARK_ADDRESS_UNVERIFIED_CONFIRMATION = "Do you want to mark this address unverified?",
  PRIMARY_DRIVER = "Primary Driver",
  SUPPORT_DRIVER = "Support Driver",
  NO_DRIVER = "No Drivers to display",
  NO_PRIMARY_DRIVER = "No Primary Driver Assigned",
  NO_SUPPORT_DRIVER = "No Support Driver Assigned",
  ASSIGNED_DRIVERS = "Assigned Drivers",
  MULTIPLE = "Multiple",
  DRIVER_DETAILS = "Driver Details",
  DRIVER_NAME = "Driver Name",
  PHONE_NUMBER = "Phone Number",
  VENDOR = "Vendor",
  OTP_SUCCESS_HEADING= "TOTP Enabled",
  OTP_SUCCESS_HEADING2= "TOTP Disabled",
  OTP_VERIFICATION_SUCCESS = "TOTP authentication is now set up for your account.",
  OTP_VERIFICATION_SUCCESS2= "TOTP authentication is now disbled for your account.",
  OTP_VERIFICATION_ERROR = "The code you entered is incorrect. Check your Auth app and enter the latest 6-digit code. ",
  RESEND_CODE = "Re-enter Code",
  SET_UP_ACCOUNT = "Set Up Account",
  SCAN_INFO = "Please use your authenticator app (for example Authy, Google Authenticator, Duo,etc) to scan this QR code:",
  SCAN_INFO_2 = "Or enter this code in your authenticator app:",
  CONTINUE = "Continue",
  DONE = "Done",
  CONFIRMATION_CODE = "Confirmation Code",
  OTP_INFO = "Please enter the",
  OTP_INFO2 = "-digit verification code in your authenticator app",
  AUTH_TEXT = "2-factor Authentication",
  AUTH_TAB_TEXT = "Authentication",
  DELIVERY_TYPE = "Delivery Type",
  VEHICLE_TYPE = "Vehicle Type",
  NOTIFICATION = "Notifications",
  MARK_AS_READ = "Mark as read",
  MARK_ALL_AS_READ = "Mark all as read",
  READ = "Read",
  UNREAD = "Unread",
  COPY_CODE = "Copy Code",
  COPIED = "Copied",
  NO_NOTIFICATIONS = "No notifications available",
  DAY_AGO = "1 day ago",
  HOUR = 'hour',
  DAY = 'day',
  APP_DOWNLOAD= "App Downloads",
  APP_DOWNLOAD_PG_TITLE = "Apps for Drivers & QC",
  APP_DOWNLOAD_BUTTON_TEXT = "Go to download page",
  COPY_LINK = "Copy Link",
  NO_DATA_TXT = "No Data",
  CLICK_REVEAL = 'Click to\nReveal',
  DRIVER_UNASSIGNED_SUCCESS_MSG = "Driver unassigned successfully",
  DELAYED = "Delayed",
  ASSIGN = "Assign",
  REASSIGN = "Reassign",
  DRIVER_LOCATION_PG_TITLE = "Live Driver Locations",
  SELECT_DRIVER = "Select Driver",
  SELECT_HELPER = "Select Helper",
  SearchPOS = "Search POS Number or Name",
  VIEW_LIVE_TRACKING = "View live tracking",
  ID_VERIFICATION_REQUIRED = "ID Verification Required",
  ID_VERIFICATION_SUCCESSFUL = "ID Verification Successful",
  ID_VERIFICATION_FAILED = "ID Verification Failed",
  ASSIGN_TO_COURIER = "Assign to courier",
  ASSIGN_TO_COURIERS = "Assign to couriers",
  ENABLE_COURIER_ASSIGNMENT = "Enable courier assignment",
  DISABLE_COURIER_ASSIGNMENT = "Disable courier assignment",
  SEARCH_COURIER = "Search courier...",
  SEARCH_COURIERS = "Search couriers",
  LOADING = "Loading...",
  NO_COURIERS_FOUND = "No couriers found",
  APPLY = "Apply",
  CANCEL = "Cancel",
  CARRIER_ASSIGNMENT_SUMMARY = "Carrier Assignment Summary",
  REVIEW_CONSIGNMENT_BREAKDOWN = "Review the consignment breakdown below before proceeding",
  COURIER_SELECTED = "Courier Selected: ",
  READY_FOR_ASSIGNMENT = "Ready for Assignment",
  READY_FOR_ASSIGNMENT_DESC = "Following orders are ready to be assigned to third party",
  CANNOT_BE_ASSIGNED = "Cannot be Assigned",
  CANNOT_BE_ASSIGNED_DESC = "Following orders cannot be assigned to third party. Please review the orders and try again",
  CONSIGNMENT_IDS = "Consignment IDs",
  SHOW_LESS = "Show less",
  SHOW_ALL = "Show all",
  ORDER = "order",
  ORDERS = "orders",
  OTHERS = "others",
  CONFIRM_ASSIGNMENT = "Confirm Assignment",
  CARRIER_SWITCHING_PROGRESS = "Carrier switching in progress",
  CARRIER_SWITCHING_SUCCESS = "Carrier switched successfully",
  CARRIER_SWITCHING_CANCELED = "Courier switch cancelled",
  CARRIER_SWITCHING_FAILED_FETCH = "Failed to fetch courier list",
  CARRIER_SWITCHING_FAILED_SWITCH= "Failed to switch courier",
  CARRIER_SWITCHING_FAILED_CONFIRM= "Failed to confirm courier switch",
  CARRIER_SWITCHING_FAILED_CANCEL= "Failed to cancel courier switch",
  CARRIER_SWITCHING_SELECT_ORDERS= "Please select orders before applying courier",
  CARRIER_SWITCHING_MISSING_INFO= "Missing required information for confirmation",
  CARRIER_SWITCHING_MISSING_CANCEL_INFO= "Missing required information for cancellation",
  CARRIER_SWITCHING_ORDER_IN_PROGRESS= "This order is currently in switching progress",
  MANUALLY_ASSIGNED= "Manually Assigned Carrier",
  LOADER_COURIER="Loading couriers...",
  ORDER_CLUBBING_SUGGESTION = "Order Clubbing Suggestion",
  LOADING_SUGGESTIONS = "Loading suggestions...",
  NO_CLUBBING_SUGGESTIONS = "No clubbing suggestions available",
  TOTAL_ITEMS = "Total Items",
  TOTAL_WEIGHT = "Total Weight",
  WEIGHT = "Weight",
  SUGGESTED_VEHICLE = "Suggested Vehicle",
  DRIVER = "Driver",
  VEHICLE = "Vehicle",
  ITEMS = "Items",
  ADDRESS = "Address:",
  NOT_ASSIGNED = "Not Assigned",
  CLUBBING = "Clubbing",
  CLUBBING_SUGGESTION_ERROR = "Please select minimum 2 consignments for Order Clubbing",
  UNEXPECTED_ERROR = "An unexpected error occurred. Please try again later.",
  VIEW_INVOICE = "View Invoice",
  NO_INVOICE = "No Invoices Available",
  NO_INVOICE_DESC = "There are no generated invoices for this consignment yet.",
  INVOICE = "Invoice",
  ASSIGN_CLUBBED = "Assign Clubbed",
  ASSIGN_MONO = "Assign Mono",
  LIMIT_REACHED = "The driver has reached maximum limit of clubbing. Cannot assign more orders.",
  LIMIT_ERROR = "Please enter a valid value between 1 and 100",
  NO_DATA_VEHICLE = "No data for this vehicle type",
}
